import { AuctionState } from "@prisma/client";
import {
  CountdownTimerIcon,
  CrossCircledIcon,
  MagnifyingGlassIcon,
  PauseIcon,
  Pencil2Icon,
  PlayIcon,
} from "@radix-ui/react-icons";

export const statusLookup: Record<AuctionState, {
  name: string;
  label: string;
  action: string;
  styling: string;
  accent: string;
  icon: React.ComponentType;
  children: AuctionState[];
}> = {
  [AuctionState.CREATING]: {
    name: "Creating",
    label: "Creating",
    action: "Create",
    styling: "",
    accent: "bg-gray-400",
    icon: Pencil2Icon,
    children: [],
  },
  [AuctionState.PREVIEW]: {
    name: "Preview",
    label: "Preview",
    action: "Preview",
    styling: "bg-amber-100 text-amber-900",
    accent: "bg-amber-300",
    icon: MagnifyingGlassIcon,
    children: [AuctionState.AUCTION],
  },
  [AuctionState.AUCTION]: {
    name: "Auction",
    label: "Active",
    action: "Manually Start",
    styling: "bg-green-100 text-green-900",
    accent: "bg-green-600",
    icon: PlayIcon,
    children: [AuctionState.PAUSED, AuctionState.MANUALLY_ENDED],
  },
  [AuctionState.PAUSED]: {
    name: "Paused",
    label: "Paused",
    action: "Pause",
    styling: "bg-amber-100 text-amber-900",
    accent: "bg-gray-400",
    icon: PauseIcon,
    children: [AuctionState.AUCTION, AuctionState.MANUALLY_ENDED],
  },
  [AuctionState.SOFT_CLOSING]: {
    name: "Soft Closing",
    label: "Soft Closing",
    styling: "bg-cyan-50 text-sky-900",
    accent: "bg-blue-400",
    icon: CountdownTimerIcon,
    action: "None",
    children: [AuctionState.MANUALLY_ENDED],
  },
  [AuctionState.MANUALLY_ENDED]: {
    name: "Ended",
    label: "Ended",
    styling: "bg-red-100 text-red-900",
    accent: "bg-red-600",
    icon: CrossCircledIcon,
    action: "End Now",
    children: [],
  },
  [AuctionState.POST_AUCTION]: {
    name: "Stopped",
    label: "Completed",
    styling: "bg-purple-100 text-purple-900",
    accent: "bg-purple-500",
    icon: CrossCircledIcon,
    action: "End now",
    children: [],
  },
  [AuctionState.ARCHIVED]: {
    name: "Archived",
    label: "Archived",
    styling: "bg-gray-100 text-gray-900",
    accent: "bg-gray-400",
    icon: CrossCircledIcon,
    action: "None",
    children: [],
  },
};
